import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/", label: "Acasă" },
  { to: "/servicii", label: "Servicii" },
  { to: "/proiecte", label: "Proiecte" },
  { to: "/despre", label: "Despre Noi" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav className="sb-navbar" data-testid="main-navbar">
        <div className="sb-navbar-inner">
          <Link to="/" className="sb-logo" data-testid="logo-link" aria-label="StructBuild Construct - Acasă">
            <span className="sb-logo-icon" aria-hidden="true">🏗️</span>
            <span className="sb-logo-text">
              <span className="name">StructBuild</span>
              <span className="sub">Construct</span>
            </span>
          </Link>

          <div className="sb-nav-links" data-testid="desktop-nav">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) => `sb-nav-link ${isActive ? "active" : ""}`}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <button
            type="button"
            className={`sb-hamburger ${open ? "open" : ""}`}
            aria-label={open ? "Închide meniul" : "Deschide meniul"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {open && (
        <div className="sb-mobile-menu" data-testid="mobile-menu">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => (isActive ? "active" : "")}
              data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </>
  );
};

export default Navbar;
